import { render } from "./SyncLogs.vue?vue&type=template&id=a4746dda&scoped=true&ts=true"
import script from "./SyncLogs.vue?vue&type=script&lang=ts"
export * from "./SyncLogs.vue?vue&type=script&lang=ts"

import "./SyncLogs.vue?vue&type=style&index=0&id=a4746dda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4746dda"]])

export default __exports__